module.exports = __webpack_public_path__ + "static/img/07_click.60d6eff6.png";